<template>
  <!-- 承运商报价 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <span>{{carrierName}} > {{ channelName }}</span>
        <el-button class="glo_btnItems glo_bgcMainColor" @click="clickReturnList">返回</el-button>
        <el-button class="glo_btnItems" @click="clickAdd">新建</el-button>
        <el-button class="glo_btnItems" @click="clickDels">批量删除</el-button>
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="clickTemplate">生成导入模板</el-dropdown-item>
            <el-dropdown-item command="clickImport">导入</el-dropdown-item>
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <!-- <el-dropdown-item command="bgsz">表格设置</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns :MoreConditions="MoreConditions" @clerBtns="clerBtns" @queryBtn_ok="queryBtn_ok" @moreParam="moreParam"></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form :model="queryData" :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'" label-position="left">
        <!-- 时间组件 -->
        <el-form-item class="queryItems" label="省:">
          <el-select v-model="queryData.endProvinceName" placeholder="请选择省" clearable filterable @change="changeProvinceQuery">
            <el-option v-for="(item, index) in SuperiorRegionListQuery" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="市:">
          <el-select v-model="queryData.endCityName" placeholder="请选择市" clearable filterable @change="changeCityQuery">
            <el-option v-for="(item, index) in cityNameListQuery" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="区:">
          <el-select v-model="queryData.endAreaName" placeholder="请选择区" clearable filterable>
            <el-option v-for="(item, index) in areaNameListQuery" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          >
            <template v-if="item.fieldIsGroup==1">
              <el-table-column
                :key="indexc"
                :label="itemc.name"
                :prop="itemc.field"
                align="center"
                :show-overflow-tooltip="true"
                :min-width="itemc.width"
                v-if=" itemc && itemc.isShow"
                v-for="(itemc, indexc) in item.child"
              ></el-table-column>
            </template>
          </el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="180px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="clickAdd(scope.row)">修改</el-button>
              <el-button class="rbtns" @click.stop="clickDels(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></paging>
    <!--        自定义表头           -->

    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 新增修改 -->
    <myDialog
      :diaWidth="diaWidthDispatch"
      :dialogTitle="dialogTitleDispatch"
      :isShowDialog="isShowDialogDispatch"
      @handleCloseDia="handleCloseDiaDispatch"
      @diaCancelBtn="handleCloseDiaDispatch"
      @diaConfirmBtn="diaConfirmBtnDispatch"
    >
      <div class="formbox" v-if="isShowDialogDispatch">
        <el-form class="glo_formBox" label-width="110px">
          <div class="formBox_item">
            <el-form-item label="线路名称:" required>
              <el-input v-model="dialogFormDispatch.offerName"></el-input>
            </el-form-item>
          </div>
          <div class="formBox_item active_item">
            <el-form-item class="formitem_one" label="目的地:" required></el-form-item>
            <el-form-item label="省:">
              <el-select v-model="dialogFormDispatch.provinceName" placeholder="请选择省" clearable filterable @change="changeProvince">
                <el-option v-for="(item, index) in SuperiorRegionList" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="市:">
              <el-select v-model="dialogFormDispatch.cityName" placeholder="请选择市" clearable filterable @change="changeCity">
                <el-option v-for="(item, index) in cityNameList" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区:">
              <el-select v-model="dialogFormDispatch.areaName" placeholder="请选择区" clearable filterable>
                <el-option v-for="(item, index) in areaNameList" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="formBox_item">
            <el-form-item label="详细地址:" style="width: 100%;">
              <el-input v-model="dialogFormDispatch.address" placeholder="请输入详细地址" clearable></el-input>
            </el-form-item>
          </div>
          <div class="formBox_item">
            <el-form-item label="目的地电话:">
              <el-input v-model="dialogFormDispatch.endPhone" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="中转类型:" required>
              <el-select filterable clearable v-model="dialogFormDispatch.transitTypeConfDictId" placeholder="请选择">
                <el-option v-for="(item,index) in transit_type_list" :key="item.confDictId" :label="item.val" :value="item.confDictId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="中转电话:" v-if="transit_type_list_firstId ==dialogFormDispatch.transitTypeConfDictId">
              <el-input v-model="dialogFormDispatch.transitPhone" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </div>
          <div class="formBox_item active_item" v-if="transit_type_list_firstId ==dialogFormDispatch.transitTypeConfDictId">
            <el-form-item class="formitem_one" label="中转城市:" required></el-form-item>
            <el-form-item label="省:">
              <el-select v-model="dialogFormDispatch.transitProvinceName" placeholder="请选择省" clearable filterable @change="changeProvince1">
                <el-option v-for="(item, index) in SuperiorRegionList1" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="市:">
              <el-select v-model="dialogFormDispatch.transitCityName" placeholder="请选择市" clearable filterable @change="changeCity1">
                <el-option v-for="(item, index) in cityNameList1" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区:">
              <el-select v-model="dialogFormDispatch.transitAreaName" placeholder="请选择区" clearable filterable>
                <el-option v-for="(item, index) in areaNameList1" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="formBox_item">
            <el-form-item label="运输天数:">
              <el-input v-model="dialogFormDispatch.transportDays" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="送货费:">
              <el-input v-model="dialogFormDispatch.dispatchFee" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="最低消费:">
              <el-input v-model="dialogFormDispatch.minConsume" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </div>
          <div class="formBox_item" v-for="(item, index) in offerAmounList">
            <el-form-item label="计费方式:">
              <el-input v-model="item.formulaBillingWeightName" disabled placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item  v-if="!item.weightAmountList || item.weightAmountList.length === 0" label="运输单价:">
              <el-input v-model="item.amount" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item v-for="(weightSection, index) in item.weightAmountList" :key="index" :label="`${weightSection.offerWeightTypeShow}:`">
              <!-- 这里可以添加显示 item 的具体内容 -->
              <el-input v-model="weightSection.amount" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </div>
          <el-form-item class="textArea" style="width: 100%" label="备注:">
            <el-input type="textarea" v-model="dialogFormDispatch.comment"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 上传组件 -->
    <input type="file" style="display: none" ref="file" @click="
        (e) => {
          e.target.value = '';
        }
      " @change="getFileData" />
    <myDialog
      :diaWidth="diaWidthDispatch1"
      :dialogTitle="dialogTitleDispatch1"
      :isShowDialog="isShowDialogDispatch1"
      @handleCloseDia="handleCloseDiaDispatch1"
      @diaCancelBtn="handleCloseDiaDispatch1"
      @diaConfirmBtn="diaConfirmBtnDispatch1"
    >
      <div class="imgprtntclass" v-if="isShowDialogDispatch1">
        <div class="filenames">{{ fileName }}</div>
        <div v-if="fileName">
          <i v-if="!isFileSuccess" class="el-icon-loading"></i>
          <i v-else style="color: #00c297" class="el-icon-success"></i>
        </div>
        <el-button class="btns" @click="uploadMaterial">选择文件</el-button>
      </div>
    </myDialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 当前页面的查询条件 -->
      <div ref="queryForm">
        <el-form :model="queryData" class="glo_form hasMoreParam" label-position="left">
          <!-- 时间组件 -->
          <el-form-item class="queryItems" label="省:">
            <el-select v-model="queryData.endProvinceName" placeholder="请选择省" clearable filterable @change="changeProvinceQuery">
              <el-option v-for="(item, index) in SuperiorRegionListQuery" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="queryItems" label="市:">
            <el-select v-model="queryData.endCityName" placeholder="请选择市" clearable filterable @change="changeCityQuery">
              <el-option v-for="(item, index) in cityNameListQuery" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="queryItems" label="区:">
            <el-select v-model="queryData.endAreaName" placeholder="请选择区" clearable filterable>
              <el-option v-for="(item, index) in areaNameListQuery" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </exportCompoent>
  </div>
</template>
<script>
import tableList from "./tableListLineQuotation.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/Dialog.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js

export default {
  mixins: [tableList, exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "承运商报价方案明细", //导出时默认文件名
        apiName: "/admin/v4/tms/carrier/getLineChannelOfferList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "Customers_NVOCCLineQuotation", //  页面标识
      reportFiledsNumber: "admin_carrier_channel_dispatch_list", // 动态 条件、表头

      isShowDialogDispatch: false,
      dialogTitleDispatch: "新增",
      diaWidthDispatch: "80%",
      dialogFormDispatch: {
        comment: "",
        address: "",
        areaName: "",
        cityName: "",
        provinceName: "",
        endPhone: "",
        offerAmounList: [],
        minConsume: "",
        offerName: "",
        transitAddress: "",
        transitAreaName: "",
        transitCityName: "",
        transitPhone: "",
        transitProvinceName: "",
        transitTypeConfDictId: "",
        transportDays: "",
        dispatchFee: "",
      },

      isShowDialogDispatch1: false,
      dialogTitleDispatch1: "明细导入",
      diaWidthDispatch1: "350px",

      carrierNumber: "",
      carrierId: "",
      carrierName: "",
      channelId: "",
      channelName: "",
      channel_offer_formula_down_list: [],
      SuperiorRegionListQuery: [], //省
      cityNameListQuery: [], //市
      areaNameListQuery: [], //区
      SuperiorRegionList: [], //省
      cityNameList: [], //市
      areaNameList: [], //区
      SuperiorRegionList1: [], //省
      cityNameList1: [], //市
      areaNameList1: [], //区
      transit_type_list: [],
      transit_type_list_firstId: "",
      queryData: {
        channelId: "",
        endProvinceName: "",
        endCityName: "",
        endAreaName: "",
      },
      offerAmounList: [],

      isFileSuccess: false,
      fileName: "",
      lineQuotationFile: "",
    };
  },
  mounted() {
    this.runPageReportDetailsitemId();
    this.getConfDictValDownList("transit_type");
    this.getParentName("中华人民共和国"); //默认查到各省
  },
  activated() {
    const { carrierId, carrierNumber, carrierName, channelId, channelName } =
      this.$route.query;
    if (carrierId) {
      this.carrierNumber = carrierNumber;
      this.carrierId = carrierId;
      this.carrierName = carrierName;
      this.channelId = channelId;
      this.channelName = channelName;
      this.queryData.channelId = channelId;
      this.initTable();
    }
  },
  watch: {},
  methods: {
    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dc") {
        // 导出
        this.exportBtn();
      }
      if (a === "dtdc") {
        // 动态列表的导出
        this.isShowDialog_dc = true;
      }
      if (a === "printBtns") {
        this.printEvent();
      }
      if (a === "printBtns") {
        this.printEvent();
      }
      if (a === "clickTemplate") {
        this.clickTemplate();
      }
      if (a === "clickImport") {
        this.clickImport();
      }
    },

    clickTemplate() {
      this.$API
        .exportCarrierDispatchChannelModel({
          channelId: this.channelId,
        })
        .then((res) => {
          let data = res.data;
          // 获取响应的文件流数据
          const blob = new Blob([data], { type: "application/vnd.ms-excel" });
          let url = URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = url;
          link.download = "承运商报价方案明细模板" + ".xlsx"; // 设置下载文件名
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(url); // 撤销URL对象
        });
    },
    clickImport() {
      // channelId
      if (this.channelId) {
        this.isShowDialogDispatch1 = true;
        this.fileName = "";
        this.isFileSuccess = false;
        this.lineQuotationFile = "";
      }
    },
    uploadMaterial() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    // 触发上传材料文件
    getFileData() {
      const inputFile = this.$refs.file.files[0];

      const file = inputFile;
      const fileName = inputFile.name;

      this.isFileSuccess = true;
      this.fileName = fileName;
      this.lineQuotationFile = file;
    },
    handleCloseDiaDispatch1() {
      this.isShowDialogDispatch1 = false;
      this.fileName = "";
      this.isFileSuccess = false;
      this.lineQuotationFile = "";
    },
    //  弹窗确认保存事件
    diaConfirmBtnDispatch1() {
      if (!this.lineQuotationFile) {
        this.$message.error("请上传明细模板");
        return false;
      }
      const form = new FormData(); //  根据后台需求数据格式
      form.append("channelId", this.channelId);
      form.append("file", this.lineQuotationFile);
      this.$showLoading();
      this.$API.importCarrierChannelDispatch(form).then((res) => {
        if (res.data.status === "success") {
          this.$message.success(res.data.message || "导入成功");
          this.isShowDialogDispatch1 = false;
          this.getData();
        } else {
          this.$message.error(`${res.data.message}---导入明细`);
        }
      });
    },
    async initTable() {
      // //获取 所有页面 number
      // await this.$API
      //   .getQueryList({
      //     number: "",
      //     reportName: "",
      //   })
      //   .then((res) => {});
      // //获取当前页面已设置表头
      // await this.$API
      //   .getGroupFindFieldSort({
      //     groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
      //   })
      //   .then((res) => {
      //     let arr = res.data.result || [];
      //     if (arr.length > 0) {
      //       if (arr[0].sortObject) {
      //         this.tabelHeadeTitle = JSON.parse(arr[0].sortObject);
      //         this.sortName = arr[0].sortName;
      //       }
      //     }
      //   });
      //表格 表头默认
      await this.$API
        .getReportFiledsV2({
          conditionReqs: [
            {
              conditonKey: "channelId",
              conditonVal: this.channelId,
            },
          ],
          number: this.reportFiledsNumber,
        })
        .then((res) => {
          let datas = res.data.result || [];
          let lists = [];
          let oldData = [];
          datas.forEach((element) => {
            let curobjs = {
              name: element.fieldNameShow,
              field: element.fieldAlias,
              width: element.wide,
              isTotal: element.isSum,
              sort: element.sort,
              isShow: element.isShow == 0 ? false : true,
              isSort: true,
              fieldIsGroup: element.fieldIsGroup,
              fieldGroupKey: element.fieldGroupKey,
              fieldGroupShow: element.fieldGroupShow,
            };
            if (element.fieldIsGroup == 1) {
              oldData.push(curobjs);
            } else {
              lists.push(curobjs);
            }
          });
          let dataInfo = {};
          oldData.forEach((item, index) => {
            let { fieldIsGroup, fieldGroupShow, fieldGroupKey } = item;
            if (!dataInfo[fieldGroupKey]) {
              dataInfo[fieldGroupKey] = {
                fieldGroupKey,
                fieldGroupShow,
                fieldIsGroup,
                name: item.fieldGroupShow,
                field: item.fieldGroupKey,
                width: item.wide,
                isTotal: item.isSum,
                sort: item.sort,
                isShow: item.isShow == 0 ? false : true,
                isSort: true,
                child: [],
              };
            }
            dataInfo[fieldGroupKey].child.push(item);
          });
          let list = Object.values(dataInfo); // list 转换成功的数据
          this.originalTabelHeadeTitle = [...lists, ...list];
          // if (!this.tabelHeadeTitle.length) {
          this.tabelHeadeTitle = this.originalTabelHeadeTitle;
          // }
        });
      this.myTableHeard = this.tabelHeadeTitle;

      let arrsConddition = [];
      // 获取查询条件 list
      await this.$API
        .getReportConditions({
          number: this.reportFiledsNumber,
        })
        .then((res) => {
          let datas = res.data.result || [];
          if (datas && datas.length > 0) {
            console.log(datas);
            datas.map((n) => (n.conditonVal = n.conditonVal || ""));
            let arrs = datas.filter((n) => {
              return n.textBoxType === "datetime";
            });
            let timeobjs = {};
            arrs.forEach((item) => {
              let { sort, conditonKeyShow } = item;
              let name = conditonKeyShow.includes("起始")
                ? conditonKeyShow.split("起始").join("")
                : conditonKeyShow.split("结束").join("");
              if (!timeobjs[sort]) {
                timeobjs[sort] = {
                  sort,
                  name,
                  children: [],
                };
              }
              timeobjs[sort].children.push(item);
            });
            let gdates = [];
            let dates = Object.values(timeobjs);
            if (dates.length) {
              console.log(dates);
              gdates = [
                {
                  textBoxType: "datetime",
                  startTime_a: this.$TOOLS.getFlexDate(this.$COMMON.timeNum),
                  endTime_a: this.$TOOLS.getCurrentDate(),
                  timeType: "0",
                  timeTypes: dates.map((n, i) => {
                    return { value: String(i), label: n.name };
                  }),
                  timeChilds: dates.map((n, i) => {
                    return { sort: n.sort, name: n.name, children: n.children };
                  }),
                },
              ];
            }
            arrsConddition = [
              ...gdates,
              ...datas.filter((n) => {
                return n.textBoxType !== "datetime";
              }),
            ];
          }
        });
      // 获取 每个查询条件 的下拉数据
      const promisemap = arrsConddition.map(async (element, index) => {
        let {
          textBoxType,
          dropdownShowField,
          dropdownApiNumber,
          defaultSelectVal,
        } = element;
        if (textBoxType == "select") {
          let selectOptions = [];
          if (defaultSelectVal) {
            await this.$API
              .runPageReport({
                conditionReqs: [
                  {
                    conditonKey: dropdownShowField,
                    conditonVal: "",
                  },
                ],
                number: dropdownApiNumber,
                pageStart: 1,
                pageTotal: 20,
              })
              .then((res) => {
                let datas = res.data.result.datas.data || [];
                selectOptions = datas;
              });
            element.conditonVal = defaultSelectVal || "";
          }
          element.selectOptions = selectOptions;
        }
      });
      await Promise.all(promisemap);
      this.queryCondditionDatas = arrsConddition;
      // this.fetTableHeight();
      setTimeout(() => {
        this.queryBtn_ok();
      }, 0);
    },
    clickReturnList() {
      this.$router.push({
        path: "/Customers/NVOCCCarrierQuotation",
        query: {
          carrierId: this.carrierId,
          carrierName: this.carrierName,
          carrierNumber: this.carrierNumber,
        },
      });
    },
    getData() {
      let params = {
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
        ...this.queryData,
      };
      this.$API.carriergetLineChannelOfferList(params).then((res) => {
        if (res.data.status === "success") {
          let datas = res.data.result || {};
          this.className = datas.className || "";
          this.tableData = datas.data || [];
          this.pageCount = datas.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },
    async clickAdd(row) {
      if (row.channelOfferId) {
        this.dialogTitleDispatch = "修改";
        await this.$API
          .carriergetLineChannelOfferDetail({
            channelOfferId: row.channelOfferId,
          })
          .then((res) => {
            if (res.data.status === "success") {
              let result = res.data.result || [];
              if (result.length) {
                let datas = result[0] || {};
                this.dialogFormDispatch = {
                  channelOfferId: row.channelOfferId,
                  comment: datas.comment,
                  address: datas.endAddress,
                  areaName: datas.endAreaName,
                  cityName: datas.endCityName,
                  provinceName: datas.endProvinceName,
                  endPhone: datas.endPhone,
                  offerName: datas.offerName,
                  transitAddress: datas.transitAddress,
                  transitAreaName: datas.transitAreaName,
                  transitCityName: datas.transitCityName,
                  transitPhone: datas.transitPhone,
                  transitProvinceName: datas.transitProvinceName,
                  transitTypeConfDictId:
                    (datas.transitTypeConfDictId &&
                      String(datas.transitTypeConfDictId)) ||
                    this.transit_type_list.find((n) => {
                      return n.key == "fei_zhong_zhuan";
                    }).confDictId,
                  transportDays: datas.transportDays,
                  dispatchFee: datas.dispatchFee,
                  minConsume: datas.minConsume,
                };

                datas.lineOfferAmounts.forEach((element) => {
                  element.formulaBillingWeightName =
                    element.formulaBillWeightName;
                });
                this.offerAmounList = datas.lineOfferAmounts;
              }
            } else {
              this_.$message.error(`${res.data.message}---综合查询列表`);
            }
          });
      } else {
        this.dialogTitleDispatch = "新增";
        this.dialogFormDispatch.transitTypeConfDictId =
          this.transit_type_list.find((n) => {
            return n.key == "fei_zhong_zhuan";
          }).confDictId;
        let firsroffer =
          (this.channel_offer_formula_down_list.length &&
            this.channel_offer_formula_down_list[0]) ||
          {};
        await this.$API
          .runPageReportDetails({
            conditionReqs: [
              {
                conditonKey: "channelId",
                conditonVal: this.channelId,
              },
            ],
            number: "admin_carrier_channel_detail_formula_list",
          })
          .then((res) => {
            if (res.data.status === "success") {
              let datas = res.data.result.datas || [];
              datas.forEach((element) => {
                element.amount = "";
                if (!element.channelOfferFormulaId) {
                  element.channelOfferFormulaId = firsroffer.id;
                  element.channelOfferFormulaName = firsroffer.name;
                }
              });
              this.offerAmounList = datas;
            } else {
              this_.$message.error(`${res.data.message}---综合查询列表`);
            }
          });
      }
      this.isShowDialogDispatch = true;
    },
    handleCloseDiaDispatch() {
      this.isShowDialogDispatch = false;
      this.dialogFormDispatch = {
        comment: "",
        address: "",
        areaName: "",
        cityName: "",
        provinceName: "",
        endPhone: "",
        offerAmounList: [],
        offerName: "",
        transitAddress: "",
        transitAreaName: "",
        transitCityName: "",
        transitPhone: "",
        transitProvinceName: "",
        transitTypeConfDictId: this.transit_type_list.find((n) => {
          return n.key == "fei_zhong_zhuan";
        }).confDictId,
        transportDays: "",
        dispatchFee: "",
        minConsume: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtnDispatch() {
      const { channelOfferId, offerName, provinceName, cityName, areaName } =
        this.dialogFormDispatch;
      if (!offerName) {
        this.$message.error("请输入线路名称");
        return false;
      }
      if (!provinceName && !cityName && !areaName) {
        this.$message.error("请选择目的地");
        return false;
      }
      let offerAmounList = [];
      this.offerAmounList.forEach((element) => {
        const { amount, channelOfferFormulaId, formulaBillingWeightId,weightAmountList } =
          element;
        offerAmounList.push({
          amount,
          channelOfferFormulaId,
          formulaBillingWeightId,
          weightAmountList
        });
      });
      this.dialogFormDispatch.offerAmounList = offerAmounList;
      let params = {
        isEnable: 1,
        channelId: this.channelId,
        ...this.dialogFormDispatch,
      };
      if (channelOfferId) {
        this.$API.carrierupdateCarrierLineOffer(params).then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.isShowDialogDispatch = false;
          this.initTable();
        });
      } else {
        this.$API.carrieraddCarrierLineOffer(params).then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.isShowDialogDispatch = false;
          this.initTable();
        });
      }
    },
    clickDels(data) {
      if (data.channelOfferId) {
        this.selectTableData = [data];
      }
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      }
      let channelOfferIds = [];
      this.selectTableData.forEach((item) => {
        channelOfferIds.push(item.channelOfferId);
      });
      this.$confirm("确定要删除所选数据吗? 请谨慎操作", "提示:")
        .then((res) => {
          this.$API
            .carrierdelLineChannelOffer({ channelOfferIds })
            .then((res) => {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
            });
        })
        .catch((err) => {});
    },

    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(type) {
      this.$COMAPI.getConfDictValDownList(type).then((res) => {
        // 计费方式
        if (type == "channel_offer_formula_down_list") {
          this.channel_offer_formula_down_list = res || [];
        }
        //中转类型
        if (type == "transit_type") {
          this.transit_type_list = res || [];
          if (this.transit_type_list.length) {
            this.transit_type_list_firstId = this.transit_type_list.find(
              (n) => {
                return n.key == "zhong_zhuan";
              }
            ).confDictId;
          }
        }
      }); //送货方式
    },
    runPageReportDetailsitemId() {
      this.$API
        .runPageReportDetails({
          number: "channel_offer_formula_down_list",
        })
        .then((res) => {
          if (res.data.status === "success") {
            let datas = res.data.result.datas || [];
            this.channel_offer_formula_down_list = datas;
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
    },
    // 选择省(收货地址)
    changeProvince(e) {
      this.dialogFormDispatch.cityName = "";
      this.dialogFormDispatch.areaName = "";
      this.cityNameList = [];
      this.areaNameList = [];
      if (e) {
        this.getCityName(e);
      }
    },
    // 选择市(收货)
    changeCity(e) {
      this.dialogFormDispatch.areaName = "";
      this.areaNameList = [];
      if (e) {
        this.getAreaName(e);
      }
    },
    // 默认查省级
    getParentName(e) {
      let p = {
        pageStart: 1,
        pageTotal: 100,
        parentName: e,
      };
      this.$API.wtl_getDistrictList(p).then((res) => {
        this.SuperiorRegionList = res.data.result.data || [];
        this.SuperiorRegionList1 = res.data.result.data || [];
        this.SuperiorRegionListQuery = res.data.result.data || [];
      });
    },
    // 获取市
    getCityName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.cityNameList = res.data.result.data || [];
        });
    },
    // 获取区
    getAreaName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.areaNameList = res.data.result.data || [];
        });
    },

    // 选择省(收货地址)
    changeProvince1(e) {
      this.dialogFormDispatch.transitCityName = "";
      this.dialogFormDispatch.transitAreaName = "";
      this.cityNameList1 = [];
      this.areaNameList1 = [];
      if (e) {
        this.getCityName1(e);
      }
    },
    // 选择市(收货)
    changeCity1(e) {
      this.dialogFormDispatch.transitAreaName = "";
      this.areaNameList1 = [];
      if (e) {
        this.getAreaName1(e);
      }
    },
    // 获取市
    getCityName1(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.cityNameList1 = res.data.result.data || [];
        });
    },
    // 获取区
    getAreaName1(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.areaNameList1 = res.data.result.data || [];
        });
    },

    // 选择省
    changeProvinceQuery(e) {
      this.queryData.cityName = "";
      this.queryData.areaName = "";
      this.cityNameListQuery = [];
      this.areaNameListQuery = [];
      if (e) {
        this.getCityNameQuery(e);
      }
    },
    // 选择市
    changeCityQuery(e) {
      this.queryData.areaName = "";
      this.areaNameListQuery = [];
      if (e) {
        this.getAreaName1Query(e);
      }
    },
    // 获取市
    getCityNameQuery(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.cityNameListQuery = res.data.result.data || [];
        });
    },
    // 获取区
    getAreaNameQuery(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.areaNameListQuery = res.data.result.data || [];
        });
    },
  },
};
</script>
<style scoped lang="less">
.textArea {
  height: auto !important;
}
.formBox_item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .el-form-item {
    width: 32%;
  }
  &.active_item {
    .el-form-item {
      width: 28%;
      &.formitem_one {
        width: 8%;
        min-width: 120px;
        border: none;
      }
    }
  }
}
.imgprtntclass {
  padding: 20px;
  display: flex;
  align-items: center;
  .btns {
    margin-left: 16px;
  }
}
</style>